<template>
<div>
    <div class="thankyou">
         <div class="container container-small text-center">
                <div :class="isLoggedIn ? 'loggedin' : 'not-loggedin'">
                     <i class="far fa-check-circle"></i>
                    <div class="heading black">{{ $t('thank_you_placed_order_title') }}</div>
                    <div class="txt" v-if='paymentMethodMessage'>
                         <div class="warning-triangle" v-if="orderHasVignetteProducts">
                              <span v-if="isLoggedIn">{{ $t('thank_you_see_info_order') }}</span>
                              <span v-else>{{ $t('thank_you_see_info_order_not_loggedin') }}</span>
                         </div>
                         <p class="main-text">
                             {{paymentMethodMessage}}
                         </p>
                         <div v-if="!isLoggedIn" class="extra-txt">
                              <p>
                                   {{ $t('thank_you_extra_info_not_loggedin') }}
                              </p>
                         </div>
                    </div>
                    <div class="action-button">
                         <router-link :to="{name: 'my-orders'}" v-if="isLoggedIn">
                              <button type="submit" class="btn btn-primary">{{ $t('thank_you_my_orders') }}</button>
                         </router-link>
                         <router-link :to="{name: 'new-account'}" v-else>
                              <button type="submit" class="btn btn-primary">
                                   {{ $t('btn_create_account') }}
                              </button>
                         </router-link>
                    </div>
               </div>
         </div>
    </div>
</div>
</template>

<script>
import RovinietaNavigation from '../RovinietaNavigation.vue'
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
    name: 'ThankYou',
    components: {
          RovinietaNavigation
    },
    mounted() {
         this.conversionEvent();
    },
    computed: {
          ...mapState('auth', [
             'isLoggedIn'
         ]),
         ...mapGetters({
             previousPaymentMethod: 'cart/getPreviousPaymentMethod',
             getPreviousOrderDetails: 'cart/getPreviousOrderDetails',
             orderHasVignetteProducts: 'cart/orderHasVignetteProducts',
             orderHasTollProducts: 'cart/orderHasTollProducts',
             hasLangInUrl: 'language/getHasLangInUrl'
         }),
         paymentMethodMessage() {
             if([2, 7, 8, 10].includes(this.previousPaymentMethod)) { //itransfer or credit card or instant credit
                 return this.$t('thank_you_itransfer_or_debit_card_or_instant_credit');
             }
             else if(this.previousPaymentMethod == 1) { // OP
                 return this.$t('thank_you_op_payment');
             }

             return false;
         }
    },
    beforeDestroy() {
         this.resetOrderHasTollAndVignette();
    },
    methods: {
        ...mapActions({
          savePreviousOrderDetailsForAnalytics: 'cart/savePreviousOrderDetailsForAnalytics',
          resetOrderHasTollAndVignette: 'cart/resetOrderHasTollAndVignette'
        }),

        conversionEvent() {
          if(this.getPreviousOrderDetails.order_id && (this.hasLangInUrl || process.env.VUE_APP_DEVICE != 'desktop')) {
               this.$gtag.event('conversion', {
                    "send_to": `${process.env.VUE_APP_GOOGLE_ADWORDS_ID}/${process.env.VUE_APP_GOOGLE_CONVERSION_LABEL}`,
                    "transaction_id": this.getPreviousOrderDetails.order_id,
                    "value": this.getPreviousOrderDetails.value,
                    "currency": "RON"
               });

               //resetting previous order to null
               this.savePreviousOrderDetailsForAnalytics({
                    order_id: null,
                    value: null
               })
          }
        }
    }
};

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

$lightgrey: lightgrey;
$green: #59af54;
$accent-color: #3F24E2;

.fa-check-circle  {
     &:before {
          font-size: 60px;
          color: $green;
     }
}
.main-text {
     font-size: 22px;
}

.txt {
     padding-top: 50px;
     padding-bottom: 50px;
     font-size: 18px;
}

.warning-triangle {
     margin-left: 27px;
     font-weight: bold;
     display: block;
     margin-bottom: 20px;

     span {
          font-size: 20px;
     }

     &:before {
          content: "\f071";
          font-family: "Font Awesome 5 Pro";
          font-weight: 700;
          padding-right: 7px;
          margin-left: -27px;
          font-size: 30px;
          color: red;
     }

     &:after {
          content: "\f071";
          font-family: "Font Awesome 5 Pro";
          font-weight: 700;
          padding-left: 7px;
          margin-right: -27px;
          font-size: 30px;
          color: red;
     }
}
.fa-check-circle {
    padding-bottom: 30px;
}
.thankyou {
     padding-bottom: 125px;
     padding-top: 125px;
     .btn {
          background-color: $accent-color;
          border-color: $accent-color;
          width: 300px;
          font-size: 18px;
          padding: 15px 0;
     }
     .fa-exclamation-triangle {
          margin-right: 5px;
     }
}

.extra-txt {
     margin-top: 40px;
}

.not-loggedin {
     .txt {
          padding-bottom: 0;
     }
}
@media only screen and (max-width: 768px) {
     .thankyou {
          padding-bottom: 60px;
          padding-top: 85px;
          .btn {
               width: 100%;
          }
          .main-text {
               padding-top: 12px;
          }
      }

      .txt {
          padding-top: 10px;
          padding-bottom: 10px;
          text-align: left;
     }
}
</style>
